<template>
  <div class="shareon">
    <a v-for="p of networks" :class="p" :key="p" @click="onPlatformClick(p)" />
  </div>
</template>

<script>
import { init } from 'shareon'
import { metrikaEvents } from '../../../services/metrika'

export default {
  name: 'Shareon',
  methods: {
    onPlatformClick(name) {
      metrikaEvents.clickOnShareon(name)
    },
  },
  mounted() {
    init()
  },
  data() {
    return {
      networks: ['whatsapp', 'vkontakte', 'telegram', 'viber'],
    }
  },
}
</script>

<style scoped>
@import 'https://cdn.jsdelivr.net/npm/shareon@2/dist/shareon.min.css';

body.presentation-table-view .shareon {
  display: flex;
  justify-content: center;
  margin-top: 13px;
}
</style>
